// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  //apiBaseUrl: "http://localhost:8081",
  //apiBaseUrl: "http://192.168.100.25:8081",
  //  apiBaseUrl: "https://localhost:7150",
  //apiBaseUrl: "http://clientapp.narola.online:1186",
apiBaseUrl: "https://eaid-backend-api-dev.azurewebsites.net"
  //apiBaseUrl: "https://localhost:44367"
};
